const VIDEO_EXTENSIONS = /\.(mp4|webm|mov)([?#].*)?$/i

export const getIsVideoUrl = (url: string) => VIDEO_EXTENSIONS.test(url)
